import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip, Form } from 'antd';
import { tCommon as t } from '../../i18n';
import { isNil } from 'lodash';

const FormItem = Form.Item;

const placeholderByLabel = (label, disablePlaceholder = false) => {
  if (!label || disablePlaceholder) return '';

  const processedLabel = label.toLowerCase();

  return t('placeholder', { label: processedLabel });
};

export default class ComponentWrapper extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
    mapProps: PropTypes.func.isRequired,
  };

  render() {
    const {
      label,
      labelCol,
      wrapperCol,
      help,
      extra,
      required,
      validateStatus,
      hasFeedback = true,
      colon,
      mapProps,
      render,
      placeholder,
      tooltip,
      meta,
      disablePlaceholder,
      ...rest
    } = this.props.mapProps(this.props);

    rest.placeholder = isNil(placeholder)
      ? placeholderByLabel(label, disablePlaceholder)
      : placeholder;
    const showError = meta?.touched && meta?.error;
    const derivedValidateStatus = showError ? 'error' : validateStatus;
    const derivedHelp = showError ? meta.error : help;

    const componentLabel = tooltip ? (
      <span>
        {label}&nbsp;
        <Tooltip title={tooltip}>
          <QuestionCircleOutlined />
        </Tooltip>
      </span>
    ) : (
      label
    );

    return (
      <FormItem
        label={componentLabel}
        wrapperCol={wrapperCol}
        labelCol={labelCol}
        help={derivedHelp}
        hasFeedback={hasFeedback}
        extra={extra}
        validateStatus={derivedValidateStatus}
        colon={colon}
        required={required}
        layout="vertical"
      >
        {render(rest)}
      </FormItem>
    );
  }
}
